import styled from 'styled-components';
import StyledCtaButton from '@/atoms/Buttons/CTA/styles';

const StyledCtaLink = styled(StyledCtaButton).attrs({as: 'a'})``;

export default StyledCtaLink;
